import { ajax } from '../../../services/helper'
class ApiService {

    getStoresData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



     getStoresTicketsData = (from,to,store_id,status,kitchen_id,city_id,platform) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTickets/list?from="+from+"&to="+to+"&store_id="+store_id+"&status="+status+"&kitchen_id="+kitchen_id+"&city_id="+city_id+"&platform="+platform
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getStoresTicketsLiveData = (kitchen_id,city_id,store_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTickets/liveList?kitchen_id="+kitchen_id+"&city_id="+city_id+"&store_id="+store_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    getSTAgentsData = (kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getPEAgents?kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPEAgentsCombolList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/employees/getCombo?type=pe_agent_list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPlatformsComboList = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo?brand_id="+id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    } 

    







    addStoreTiming  = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTimings/add"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     addSTAgentKichen  = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/agentAssignments/add"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }




    updateStoreTiming = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTimings/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    deleteStoreTiming = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTimings/"+id+"/delete"
            ajax(url,'POST')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    deleteAssignedKitchen = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/agentAssignments/"+id+"/delete"
            ajax(url,'POST')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     getStoresTicketDetails = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTickets/"+id+"/editInfo"
            ajax(url,'POST')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


     assignAgentStoreTicket = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTickets/"+id+"/assign"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

    getStoreTicketReasonslList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/reasons/getCombo?type=STORE_TICKET"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     updateStoreTicket = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/storeTickets/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getStoresCombolList = (kitchen_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/getCombo?kitchen_id="+kitchen_id
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    

     getAgentNonAssignedKitchensComboList = () => {
        return new Promise((resolve, reject) => {
                const url = "/v1/kitchens/getAgentNonAssignedCombo"
                ajax(url, 'GET')
                    .then(res => resolve(res))
                    .catch(err => reject(err))
            })
    }

    

    getStoreDetailsById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/"+id+"/editInfo"
            ajax(url,'POST')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



      addStore = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

      getStoreById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editStore = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/stores/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
    

    

}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Stores/services/apiservices.js